export default __webpack_public_path__ + "img/tmxcJkXR.1692ac25.svg";